<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Layout',
})
</script>
<!--
 * @Descripttion: 
 * @Author: Junteng Shi
 * @Date: 2025-03-24 16:07:55
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-06-25 10:19:39
-->
<template>
  <div id="app-container" class="w-full h-full overflow-hidden">
    <el-container w-full h-full>
      <el-aside width="228px" style="border: 1px solid #dddddd">
        <Menu />
      </el-aside>
      <el-container>
        <el-main class="bg-#F3F4FF" pt-0px id="content-container">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script lang="ts" setup name="Layout">
  import Menu from '@/layout/components/menu.vue';
</script>

<style scoped>
  #app-container {
    min-width: 1200px;
  }
</style>
